function toggleDropdown(event) {
    var dropdownElement = event.currentTarget;

    if (dropdownElement.classList.contains('open')) {
        // If it has the 'open' class, remove it.
        dropdownElement.classList.remove('open');
    } else {
        // If it doesn't have the 'open' class, add it.
        dropdownElement.classList.add('open');
    }
}

// ==== Money formatting helpers (match money_without_trailing_zeros) ====
function getCurrencyFormat() {
    try {
        if (window.themeVariables && window.themeVariables.settings) {
            return window.themeVariables.settings.moneyFormat || "$ {{amount}}";
        }
    } catch (e) {}
    return "$ {{amount}}";
}

function toNoDecimalPlaceholder(placeholder) {
    switch (placeholder) {
        case 'amount': return 'amount_no_decimals';
        case 'amount_with_comma_separator': return 'amount_no_decimals_with_comma_separator';
        case 'amount_with_space_separator': return 'amount_no_decimals_with_space_separator';
        case 'amount_with_apostrophe_separator': return 'amount_no_decimals_with_apostrophe_separator';
        default: return 'amount_no_decimals';
    }
}

function formatMoney(cents, formatString) {
    if (typeof cents === 'string') {
        cents = cents.replace(/[.,]/g, '');
    }
    cents = parseFloat(cents);
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(value, def) { return value == null || value !== value ? def : value; }
    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');
        if (isNaN(number) || number == null) return 0;
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsPart = parts[1] ? decimal + parts[1] : '';
        return dollars + centsPart;
    }

    const match = (formatString || getCurrencyFormat()).match(placeholderRegex);
    const placeholder = match ? match[1] : 'amount';
    let value = '';
    switch (placeholder) {
        case 'amount': value = formatWithDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
        case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
        case 'amount_no_decimals_with_apostrophe_separator': value = formatWithDelimiters(cents, 0, "'"); break;
        default: value = formatWithDelimiters(cents, 2); break;
    }
    return (formatString || getCurrencyFormat()).replace(placeholderRegex, value);
}

function formatMoneyWithoutTrailingZeros(cents) {
    const fmt = getCurrencyFormat();
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = fmt.match(placeholderRegex);
    let formatToUse = fmt;
    if (match && (cents % 100 === 0)) {
        const noDec = toNoDecimalPlaceholder(match[1]);
        formatToUse = fmt.replace(placeholderRegex, '{{' + noDec + '}}');
    }
    return formatMoney(cents, formatToUse);
}

async function selectSellingPlan(event) {
    var planElement = event.currentTarget;

    var newSellingPlan = parseInt(planElement.getAttribute('data-plan-id'));
    var newSellingPlanName = planElement.getAttribute('data-plan-name');
    var lineItemIndex = parseInt(planElement.getAttribute('data-line-item-index'));

    const updated = await updateSellingPlan(lineItemIndex, newSellingPlan)

    if (updated) {
        //change the plan name displayed
        const selectedPlanNameId = 'selected-option-name-' + lineItemIndex.toString()
        const selectedPlanNameElement = document.getElementById(selectedPlanNameId)
        selectedPlanNameElement.textContent = newSellingPlanName;
        selectedPlanNameElement.setAttribute('data-selected-plan-id', newSellingPlan.toString())

        //if you select a plan, make sure that subscribe radio is selected
        const subscribeRadioId = 'subscribe-' + lineItemIndex.toString()
        let subscribeRadio = document.getElementById(subscribeRadioId)
        if (subscribeRadio) {
            subscribeRadio.checked = true;
        }

        const oneTimeRadioId = 'oneTime-' + lineItemIndex.toString()
        let oneTimeRadio = document.getElementById(oneTimeRadioId)
        if (oneTimeRadio) {
            oneTimeRadio.checked = false;
        }
    }
}

function updatePrice(lineItemIndex, newPrice) {
    const line_item = document.querySelector(`[data-product-price-line-index="${lineItemIndex}"]`);

    if(!line_item){
        return
    }

    // Use textContent instead of innerHTML to avoid triggering any HTML parsing
    // This is faster and won't cause re-renders of child elements
    // However, if newPrice contains HTML (like <span> tags), we need innerHTML
    // Let's check if it contains HTML tags
    if (newPrice.includes('<')) {
        // Contains HTML, use innerHTML
        line_item.innerHTML = newPrice;
    } else {
        // Plain text, use textContent (faster, no reflow)
        line_item.textContent = newPrice;
    }
    
    return;
}

async function updateSellingPlan(lineItemIndex, newSellingPlanId) {
    const ajaxUrl = window.Shopify.routes.root + 'cart/change.js';
    try {
        // Get the current quantity from the DOM to preserve it when changing selling plan
        const quantityInput = document.querySelector(`.quantity-selector__input[data-line="${lineItemIndex}"]`);
        const currentQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
        
        let response = await fetch(ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                line: lineItemIndex,
                selling_plan: newSellingPlanId,
                quantity: currentQuantity, // Preserve quantity when changing selling plan
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        let data = await response.json();
        
        // Fetch the updated mini-cart HTML to get the properly formatted price with strikethrough
        const sectionId = document.querySelector('cart-drawer')?.getAttribute('section') ||
            document.getElementById('mini-cart-page')?.dataset.sectionId;
        const sectionResponse = await fetch(`${window.themeVariables.routes.cartUrl}?section_id=${sectionId}`);
        const sectionHTML = await sectionResponse.text();
        
        // Parse the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHTML, 'text/html');
        
        // Find the updated line item price HTML
        const allPriceElements = doc.querySelectorAll('[data-product-price-line-index]');
        const updatedPriceEl = Array.from(allPriceElements).find(el => 
            el.getAttribute('data-product-price-line-index') == lineItemIndex
        );
        
        // Batch DOM updates in a single frame to prevent flash
        requestAnimationFrame(() => {
            if (updatedPriceEl) {
                // Get current price element
                const currentPriceEl = document.querySelector(`[data-product-price-line-index="${lineItemIndex}"]`);
                if (currentPriceEl) {
                    // Replace with new price HTML (includes strikethrough when needed)
                    // Using innerHTML is necessary for complex price structure
                    currentPriceEl.innerHTML = updatedPriceEl.innerHTML;

                    // Also refresh the second row (containing discount text) so "Save X%" matches plan
                    const currentInfo = currentPriceEl.closest('.athena-line-item__item-info-container');
                    const newInfo = updatedPriceEl.closest('.athena-line-item__item-info-container');
                    const currentSecond = currentInfo?.querySelector('.athena-line-item__second-row');
                    const newSecond = newInfo?.querySelector('.athena-line-item__second-row');
                    if (currentSecond && newSecond) {
                        currentSecond.innerHTML = newSecond.innerHTML;
                    }

                    // Also refresh the line-item anchor hrefs so {{ line_item.url }} reflects the new selling_plan param
                    const currentLineItem = currentPriceEl.closest('athena-line-item');
                    const newLineItem = updatedPriceEl.closest('athena-line-item');
                    if (currentLineItem && newLineItem) {
                        const anchorSelectors = ['.athena-line-item__image-wrapper', '.athena-line-item__title'];
                        anchorSelectors.forEach((sel) => {
                            const currentAnchor = currentLineItem.querySelector(sel);
                            const newAnchor = newLineItem.querySelector(sel);
                            if (currentAnchor && newAnchor) {
                                currentAnchor.setAttribute('href', newAnchor.getAttribute('href'));
                            }
                        });
                    }
                }
            }
            // Update subtotal in same frame
            const cartContent = data; // Use data from change.js response
            const subtotalEl = document.querySelector('.mini-cart__subtotal-amount');
            if (subtotalEl) {
                subtotalEl.textContent = formatMoneyWithoutTrailingZeros(cartContent.total_price);
            }
        });
        
        console.log('[Cart] Subscription updated surgically');
        
        return true;

    } catch (error) {
        console.error('Error:', error);
        return false;
    }
}

// Update subtotal without full re-render
function updateSubtotalInline(newTotalPrice) {
    const subtotalEl = document.querySelector('.mini-cart__subtotal-amount');
    if (subtotalEl) {
        const formattedPrice = formatMoneyWithoutTrailingZeros(newTotalPrice);
        
        // Update text content directly - NO animations, NO class changes
        subtotalEl.textContent = formattedPrice;
        
        // NO animations - keep it silent and smooth
    }
}



// Hook for native select change
window.selectNativeSellingPlan = async function(event) {
    const selectEl = event.target;
    const lineItemIndex = parseInt(selectEl.getAttribute('data-line-item-index'));
    const newSellingPlan = selectEl.value ? parseInt(selectEl.value) : null;
    await updateSellingPlan(lineItemIndex, newSellingPlan);
}

// Toggle UI for native select vs save badge
window.radioClicked = async function(event) {
    var radioElement = event.currentTarget;
    var lineItemIndex = parseInt(radioElement.getAttribute('data-line-item-index'));
    var isSubscribe = radioElement.value === 'subscribe';
    var nativeSelectWrap = document.getElementById('native-select-' + lineItemIndex);
    var saveBadge = document.getElementById('save-badge-' + lineItemIndex);

    // When subscribing: show native select, hide save badge
    // When one-time: hide native select, show save badge
    if (nativeSelectWrap) nativeSelectWrap.style.display = isSubscribe ? 'flex' : 'none';
    if (saveBadge) saveBadge.style.display = isSubscribe ? 'none' : 'flex';
    
    if (!isSubscribe) {
        await updateSellingPlan(lineItemIndex, null);
    } else {
        const selectEl = nativeSelectWrap ? nativeSelectWrap.querySelector('select') : null;
        if (selectEl && selectEl.value) {
            await updateSellingPlan(lineItemIndex, parseInt(selectEl.value));
        }
    }
}